import axios from "axios";


function configureHealthEstimateAPI(options) {
    const apiUrl = `${options.baseUrl}/estimate-health`;

    return {
        async postPrices(data) {
            const response = await axios.post(`${apiUrl}/prices`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        },
        async postEstimate(data) {
            const response = await axios.post(`${apiUrl}/receiveEstimate`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        }
    };
}

export { configureHealthEstimateAPI };